import Icon from '@/components/ui/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'ShieldCheckIcon',
      title: 'Licensed & Insured',
      description: 'Fully licensed and insured for your peace of mind',
    },
    {
      icon: 'ClockIcon',
      title: '24-Hour Response',
      description: 'Quick quote turnaround within 24 hours',
    },
    {
      icon: 'StarIcon',
      title: '500+ Happy Customers',
      description: 'Trusted by Phoenix Metro homeowners',
    },
    {
      icon: 'CheckBadgeIcon',
      title: 'Satisfaction Guarantee',
      description: 'We stand behind our work 100%',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {trustFeatures.map((feature, index) => (
        <div
          key={index}
          className="flex items-start space-x-4 p-4 rounded-lg bg-card border border-border"
        >
          <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={feature.icon as any} size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="font-headline font-semibold text-foreground mb-1">
              {feature.title}
            </h3>
            <p className="text-sm text-muted-foreground font-body">
              {feature.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;